module.exports = __webpack_public_path__ + "static/media/Container_ship.ff293d4e.svg";